import { gql } from "@apollo/client";

export const SUGGEST_NEW_COURSE = gql`
  mutation suggestNewCourse($title: String!, $university: String!) {
    addCourseSuggestion(title: $title, university: $university)
  }
`;
